import React from 'react';
import { WHY_IT_WORKS } from '../lib/content';
import { Reveal } from './Reveal';
const CARD_COLORS = [{
  bg: 'bg-[#F0F7FF]',
  iconBg: 'bg-[#E0EDFF]'
}, {
  bg: 'bg-[#FFF5ED]',
  iconBg: 'bg-[#FFE8D6]'
}, {
  bg: 'bg-[#EBF7ED]',
  iconBg: 'bg-[#D6F0DB]'
}];
export function WhyItWorks() {
  return <section className="w-full bg-gradient-to-b from-[#FFF5ED] via-white to-white py-16 sm:py-24" data-id="element-615" data-mp="2x247jfopzuqx">
      <div className="mx-auto w-full max-w-2xl px-5 sm:px-8" data-id="element-616" data-mp="3kros230iv02b">
        <Reveal className="text-center" data-id="element-617" data-mp="3kqdrsd6acafy">
          <span className="inline-flex items-center gap-1.5 rounded-full bg-white px-4 py-1.5 font-display text-[10px] font-black uppercase tracking-widest text-[#FF6B35] shadow-sm sm:text-xs" data-id="element-618" data-mp="3prjmggjia7s4">
            {WHY_IT_WORKS.badge}
          </span>
          <h2 className="mx-auto mt-6 max-w-xs text-4xl font-black leading-[1.1] text-[#1C3587] sm:max-w-none sm:text-5xl font-['Tiro_Gurmukhi',_serif]" data-id="element-619" data-mp="3gspsyz1h1xis">
            {WHY_IT_WORKS.title}
          </h2>
          <p className="mx-auto mt-4 max-w-md font-display text-[15px] font-bold leading-snug text-[#4A5568] sm:text-lg" data-id="element-620" data-mp="259dch8irwc39">
            {WHY_IT_WORKS.description}
          </p>
        </Reveal>

        <div className="mt-10 flex flex-col gap-3 sm:gap-4" data-id="element-621" data-mp="3pbwzgmrvwehi">
          {WHY_IT_WORKS.points.map((point, i) => {
          const colorStyle = CARD_COLORS[i % CARD_COLORS.length];
          return <Reveal key={i} delay={i * 0.1} float={true} data-id="element-622" data-mp="34yrht4c9h17" data-mpi={i}>
                <div className={`flex items-center gap-4 rounded-2xl border-l-[6px] border-[#FF6B35] p-4 shadow-[0_4px_20px_rgba(0,0,0,0.04)] sm:p-5 ${colorStyle.bg}`} data-id="element-623" data-mp="h1lq00bxwf98">
                  <span className={`flex h-12 w-12 flex-none items-center justify-center rounded-2xl text-2xl shadow-sm ${colorStyle.iconBg}`} aria-hidden="true" data-id="element-624" data-mp="qs6w08ty0m26">
                    {point.emoji}
                  </span>
                  <div className="flex-1 text-left" data-id="element-625" data-mp="zsd3ne2ymrtf">
                    <h3 className="font-display text-[15px] font-black leading-tight text-[#1C3587] sm:text-lg" data-id="element-626" data-mp="zqs9vqogzcwm">
                      {point.title}
                    </h3>
                    <p className="mt-0.5 text-[12px] font-bold text-[#4A5568] sm:text-sm" data-id="element-627" data-mp="12wath1atfg7t">
                      {point.description}
                    </p>
                  </div>
                </div>
              </Reveal>;
        })}
        </div>
      </div>
    </section>;
}